u<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Invites</h1>
        </template>

        <p class="">Your friends are yet to experience calmness in their inboxes. Invite them with a single-click and we'll take it from there.</p>
        
        <section class="mt-4 h-64 overflow-y-scroll text-sm">
            <ul>
                <li class="p-2 border-b border-gray-light" v-for="(contact, index) in contacts" :key="contact.id">
                    <div class="flex items-center justify-between">
                        <p class="flex flex-col">
                            {{ contact.email }}
                        </p>
                        <progressable-button 
                            type="submit"
                            class="px-1 text-primary font-bold"
                            :state="'Inviting...'"
                            :loading="contact.is_inviting"
                            @click.native="invite(index)">
                            Invite
                        </progressable-button>
                    </div>
                </li>
            </ul>
        </section>
        <small class="text-gray-darker text-right block">Scroll to load more.</small>
    </modal-component>
</template>

<script>
export default {
    data() {
        return {
            contacts: [],
        }
    },
    mounted() {
        this.loadContacts();
    },
    methods: {
        loadContacts() {
            axios.get('/api/contacts?uninvited=true&per_page=200')
                .then(response => {
                    this.contacts = response.data.data;
                })
                .catch(console.error);
        },
        invite(index)
        {
            var contactToInvite = this.contacts[index];
            
            this.$set(this.contacts[index], 'is_inviting', true);
            axios.post(`/api/contacts/${contactToInvite.id}/invites`)
                .then(() => {
                    // filter contacts
                    this.contacts = this.contacts.filter(contact => {
                        return contact.id !== contactToInvite.id;
                    })
                })
                .catch(console.error)
                .finally(() => {
                    this.$set(this.contacts[index], 'is_inviting', false);
                });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>